<h1 mat-dialog-title>Insufficient Credits</h1>
<div mat-dialog-content>
  <p>Your organization does not have sufficient credits for another statement upload.</p>
  @if (!isOrgAdminUser) {
    <p>Contact your Organization Admin to add more credits to your account.</p>
  }

  @if (isOrgAdminUser && !isFreeTrialAccount) {
    <button mat-raised-button color="primary" class="mb-1" routerLink="/manage/organization-settings/organization-billing" mat-dialog-close>
      Buy More Credits
    </button>
  }
  @if (isFreeTrialAccount) {
    <button mat-raised-button color="primary" class="mb-1" routerLink="/manage/upgrade-account" mat-dialog-close>
      Upgrade Account
    </button>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="dialogRef.close('OK')" type="submit" color="accent">OK</button>
</div>
